import React from "react";

export default function NotesIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg viewBox="0 0 14 14" style={{ ...filteredStyles, fill: "none" }} className={props.className} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1462_831)">
        <path
          d="M12.6151 1.38445C12.4229 1.19148 12.1944 1.03851 11.9428 0.934381C11.6911 0.830251 11.4213 0.777025 11.149 0.777779H2.85012C2.30039 0.777779 1.77317 0.99616 1.38445 1.38488C0.995725 1.7736 0.777344 2.30082 0.777344 2.85056V11.1494C0.777344 11.6992 0.995725 12.2264 1.38445 12.6151C1.77317 13.0038 2.30039 13.2222 2.85012 13.2222H10.239C10.5539 13.2227 10.8571 13.1031 11.0868 12.8878L12.8329 11.2778C12.9563 11.1606 13.0545 11.0195 13.1214 10.863C13.1882 10.7065 13.2224 10.538 13.2218 10.3678V2.85056C13.2228 2.57819 13.1696 2.30834 13.0655 2.05666C12.9613 1.80498 12.8083 1.57649 12.6151 1.38445ZM1.97123 12.0283C1.85509 11.9134 1.76296 11.7765 1.70021 11.6256C1.63745 11.4747 1.60532 11.3129 1.60568 11.1494V2.85056C1.60568 2.52051 1.73679 2.20398 1.97017 1.9706C2.20355 1.73722 2.52007 1.60611 2.85012 1.60611H11.149C11.4791 1.60611 11.7956 1.73722 12.029 1.9706C12.2623 2.20398 12.3935 2.52051 12.3935 2.85056V9.55111H10.6707C10.5087 9.54802 10.3477 9.57718 10.1971 9.63692C10.0465 9.69666 9.9093 9.78576 9.79348 9.89905C9.67766 10.0123 9.58554 10.1475 9.52249 10.2968C9.45944 10.446 9.42672 10.6063 9.42623 10.7683V12.3939H2.85012C2.68671 12.3943 2.52485 12.3621 2.37397 12.2994C2.22309 12.2366 2.08619 12.1445 1.97123 12.0283ZM10.5268 12.2811C10.4501 12.3537 10.3485 12.394 10.2429 12.3939V10.7644C10.2428 10.711 10.2537 10.6581 10.2749 10.6091C10.2961 10.56 10.3272 10.5159 10.3663 10.4794C10.4053 10.4429 10.4514 10.4148 10.5018 10.397C10.5522 10.3791 10.6057 10.3718 10.659 10.3756H12.3818C12.3806 10.4312 12.3683 10.486 12.3456 10.5367C12.3229 10.5875 12.2902 10.6332 12.2496 10.6711L10.5268 12.2811Z"
          fill={filteredStyles.fill}
        />
        <path d="M4.09473 4.92722H9.90084V5.75555H4.09473V4.92722Z" fill={filteredStyles.fill} />
        <path d="M4.09473 6.58389H6.99973V7.41223H4.09473V6.58389Z" fill={filteredStyles.fill} />
      </g>
      <defs>
        <clipPath id="clip0_1462_831">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
